import axiosInstance from "../../../../../../API/axios";
import { API_ENDPOINTS } from './SupportRequestTab.constants';

/**
 * Fetches users for a specific department
 * @param {string} endpoint - API endpoint
 * @returns {Promise<Array>} - Promise resolving to users array
 */
export const fetchDepartmentUsers = async (endpoint) => {
    try {
        const response = await axiosInstance.get(endpoint);
        return response.data || [];
    } catch (error) {
        console.error(`Error fetching users from ${endpoint}:`, error);
        return [];
    }
};

/**
 * Resets support selections when support is disabled
 * @param {Object} setters - Object containing setter functions
 */
export const resetSupportSelections = (setters) => {
    const {
        setMarketingSupport,
        setSupplyChainSupport,
        setSelectedMarketingMember,
        setSelectedSupplyChainMember
    } = setters;

    if (setMarketingSupport) setMarketingSupport(false);
    if (setSupplyChainSupport) setSupplyChainSupport(false);
    if (setSelectedMarketingMember) setSelectedMarketingMember(null);
    if (setSelectedSupplyChainMember) setSelectedSupplyChainMember(null);
};

/**
 * Creates handler for checkbox/switch changes
 * @param {Function} setter - Setter function
 * @param {boolean} disabled - Whether component is disabled
 * @returns {Function|undefined} - Handler function or undefined if disabled
 */
export const createChangeHandler = (setter, disabled) => {
    if (disabled || !setter) return undefined;
    return (event) => setter(event.target.checked);
};

/**
 * Creates handler for autocomplete changes
 * @param {Function} setter - Setter function
 * @param {boolean} disabled - Whether component is disabled
 * @returns {Function|undefined} - Handler function or undefined if disabled
 */
export const createAutocompleteHandler = (setter, disabled) => {
    if (disabled || !setter) return undefined;
    return (_, newValue) => setter(newValue);
};